import { render, staticRenderFns } from "./passiveticketlist.vue?vue&type=template&id=2d927af2"
import script from "./passiveticketlist.vue?vue&type=script&lang=js"
export * from "./passiveticketlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports